// extracted by mini-css-extract-plugin
module.exports = {"editButton":"EditableSectionBox_editButton__107Qh","actionSkeleton":"EditableSectionBox_actionSkeleton__rzVBK"};